/**
 * Export Marketer Report Use Case
 *
 * Business logic for exporting marketer reports
 */

import {ReportsRepository} from '../repository/ReportsRepository';
import {ExportResponse, MarketerStoresReport, ExportRequest} from '../models/report.model';

export class ExportMarketerReportUseCase {
  constructor (private reportsRepository: ReportsRepository) {}

  async execute (marketerId: number, request: ExportRequest): Promise<ExportResponse | MarketerStoresReport> {
    try {
      // Validate marketer ID
      if (!marketerId || marketerId <= 0) {
        throw new Error('Invalid marketer ID');
      }

      // Validate export format
      const validFormats = ['excel', 'pdf', 'json'];
      if (!validFormats.includes(request.format)) {
        throw new Error('Invalid export format. Must be excel, pdf, or json');
      }

      // Validate date filters if provided
      if (request.date_from && request.date_to) {
        const fromDate = new Date(request.date_from);
        const toDate = new Date(request.date_to);

        if (fromDate > toDate) {
          throw new Error('Start date cannot be after end date');
        }
      }

      return await this.reportsRepository.exportMarketerReport(marketerId, request);
    } catch (error) {
      throw new Error(`Failed to export marketer report: ${error instanceof Error ? error.message : 'Unknown error'}`);
    }
  }
}


